import { computed as t, unref as n, ref as f } from "vue";
import { useZIndex as l } from "./index623.js";
import { useNamespace as z } from "./index559.js";
import { isNumber as a } from "./index565.js";
const w = (e, {
  attributes: s,
  styles: c,
  role: p
}) => {
  const { nextZIndex: d } = l(), o = z("popper"), u = t(() => n(s).popper), r = f(
    a(e.zIndex) ? e.zIndex : d()
  ), x = t(() => [
    o.b(),
    o.is("pure", e.pure),
    o.is(e.effect),
    e.popperClass
  ]), m = t(() => [
    { zIndex: n(r) },
    n(c).popper,
    e.popperStyle || {}
  ]), i = t(
    () => p.value === "dialog" ? "false" : void 0
  ), I = t(
    () => n(c).arrow || {}
  );
  return {
    ariaModal: i,
    arrowStyle: I,
    contentAttrs: u,
    contentClass: x,
    contentStyle: m,
    contentZIndex: r,
    updateZIndex: () => {
      r.value = a(e.zIndex) ? e.zIndex : d();
    }
  };
};
export {
  w as usePopperContentDOM
};
